import {
  FormatPersonName,
  MapFamilyMembers,
  ValueType,
  parseFormValue,
  vendorContactSearchInfo,
  vendorSearchInfo
} from './formDataConstants';
import { enumColumn } from 'modules/common/enumTableColumn';

export const createGlobalDestinationPostRequest = (formData, globalId) => {
  const request = { ...formData };
  request.globalAssignmentId = globalId;
  request.modifiedBy = 1; // TODO: replace with actual user id
  request.modifiedOn = new Date().toISOString();
  request.addedBy = 1; // TODO: replace with actual user id
  request.addedOn = new Date().toISOString();
  parseDestinationServiceFormValues(request, formData);
  return request;
};

export const createGlobalDestinationPutRequest = (originalFormData, newFormData, globalId) => {
  const request = { ...newFormData };
  request.globalAssignmentId = globalId;
  request.globalDestinationServiceId = originalFormData.globalDestinationServiceId;
  request.modifiedBy = 1; // TODO: replace with actual user id
  request.modifiedOn = new Date().toISOString();
  request.addedBy = originalFormData.addedBy;
  request.addedOn = originalFormData.addedOn;
  // ensure all transforms happen consistently
  parseDestinationServiceFormValues(request, newFormData);
  return request;
};

export const createGlobalDestinationRows = formDataList => {
  if (!formDataList || !Array.isArray(formDataList)) return [];

  return formDataList.map(data => ({
    ...data,
    contactId: data.destinationServiceCompanyContact,
    vendorId: data.destinationServiceCompanyId,
    familyMemberIds: data.familyMemberIds && typeof data.familyMemberIds === 'string' && data.familyMemberIds.trim() !== ''
      ? data.familyMemberIds.split(',').map(id => {
          const trimmed = id.trim();
          const parsed = parseInt(trimmed);
          return isNaN(parsed) ? trimmed : parsed;
        }).filter(id => id !== '' && id !== null)
      : (Array.isArray(data.familyMemberIds) ? data.familyMemberIds : []),
    initiationDate: parseFormValue(data.initiationDate, ValueType.DateTimeType),
    cancelledDate: parseFormValue(data.cancelledDate, ValueType.DateTimeType),
    completedDate: parseFormValue(data.completedDate, ValueType.DateTimeType)
  }));
};

export const createGlobalDestinationColumns = (vendors, vendorContacts, enumerations, allVendors, familyMembers) => {
  return [
    {
      ...enumColumn('familyMemberIds', familyMembers, { valueKey: 'familyMemberId', label: FormatPersonName }),
      header: 'Family Member',
      type: 'multi-select-v2',
      required: false,
      options: MapFamilyMembers(familyMembers),
      size: 65,
      Cell: ({ cell }) => cell.getValue() || '-'
    },
    {
      ...enumColumn('vendorId', allVendors, { valueKey: 'vendorId', label: 'companyName' }),
      header: 'Company',
      nameKey: 'companyName',
      searchInfo: vendorSearchInfo(vendors),
      type: 'advanced-search',
      required: true,
      size: 65
    },
    {
      ...enumColumn('contactId', vendorContacts, { valueKey: 'contactId', label: FormatPersonName }),
      header: 'Vendor Contact',
      nameKey: 'fullName',
      searchInfo: vendorContactSearchInfo(vendorContacts),
      type: 'advanced-search',
      required: false,
      size: 65,
      Cell: ({ cell }) => cell.getValue() || '-'
    },
    {
      accessorKey: 'initiationDate',
      header: 'Ordered Date',
      type: 'date',
      required: true,
      size: 65,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    {
      accessorKey: 'cancelledDate',
      header: 'Cancelled Date',
      type: 'date',
      hideInTable: true,
      size: 65,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    {
      accessorKey: 'completedDate',
      header: 'Completed Date',
      type: 'date',
      size: 65,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    { accessorKey: 'daysAuthorized', header: 'Days Authorized', type: 'number', hideInTable: false, size: 65 },
    { accessorKey: 'daysUtilized', header: 'Days Utilized', type: 'number', hideInTable: true, size: 65 },
    { accessorKey: 'serviceNote', header: 'Service Note', type: 'text', hideInTable: true, size: 65 }
  ];
};

const parseDestinationServiceFormValues = (currentRequest, newRequestValues) => {
  currentRequest.destinationServiceCompanyId = newRequestValues.vendorId ?? null;
  currentRequest.destinationServiceCompanyContact = newRequestValues.contactId && typeof newRequestValues.contactId === 'number' ? newRequestValues.contactId : null;
  // Store familyMemberIds as comma-separated string for DB
  if (Array.isArray(newRequestValues.familyMemberIds)) {
    // Handle array of objects {id, title} from multi-select-v2
    currentRequest.familyMemberIds = newRequestValues.familyMemberIds
      .map(item => typeof item === 'object' ? item.id : item)
      .join(',');
  } else {
    currentRequest.familyMemberIds = newRequestValues.familyMemberIds ?? '';
  }
  currentRequest.description = Array.isArray(newRequestValues.description)
    ? newRequestValues.description.join(', ')
    : newRequestValues.description ?? '';
  currentRequest.initiationDate = parseFormValue(newRequestValues.initiationDate, ValueType.DateTimeType);
  currentRequest.cancelledDate = parseFormValue(newRequestValues.cancelledDate, ValueType.DateTimeType);
  currentRequest.completedDate = parseFormValue(newRequestValues.completedDate, ValueType.DateTimeType);
  currentRequest.daysAuthorized = parseFormValue(newRequestValues.daysAuthorized, ValueType.IntType);
  currentRequest.daysUtilized = parseFormValue(newRequestValues.daysUtilized, ValueType.IntType);
  currentRequest.serviceNote = newRequestValues.serviceNote ?? '';
};
